import { type ReactNode } from 'react';
import { trans } from '@lingoda/i18n';
import { Box, Stack, Typography } from '@lingoda/ui';

interface Props {
    isCouponAvailable?: boolean;
    children: ReactNode;
}

export const CouponLayout = ({ children, isCouponAvailable }: Props) => (
    <Box>
        {isCouponAvailable ? (
            <Stack spacing={2}>
                <Typography variant="body1">
                    {trans('coupon-code-description', {}, 'public-payment')}
                </Typography>
                <Box>{children}</Box>
            </Stack>
        ) : (
            <Typography>{trans('coupon-not-available', {}, 'public-common')}</Typography>
        )}
    </Box>
);
